import React from 'react'
import { PageHeader } from "antd";
import AdminBreadCrumb from '../../components/layout/AdminBreadCrumb';
import StudentDueComp from '../../components/studentDueComp/StudentDueComp';

const StudentDue = () => {
    return (
        <div className="inside-main-content">
            <AdminBreadCrumb />

            <div className="box-style">
                <PageHeader
                    ghost={false}
                    onBack={() => window.history.back()}
                    title="Student Due"
                    subTitle=""
                    extra={[]}
                ></PageHeader>

                <StudentDueComp />

            </div>
        </div>
    )
}

export default StudentDue